module.exports = __webpack_public_path__ + "img/kr.e7ceeb08.svg";